module.exports = __webpack_public_path__ + "img/11.32d4e9a6.png";